import { DefaultUrlSerializer, UrlTree } from '@angular/router';
import { addSlashToBasePath } from '../slash-suffix-processor/add-slash-to-path';

// Стратегия сериализации URL с '/' в конце
export class SlashUrlSerializer extends DefaultUrlSerializer {
  override parse(url: string): UrlTree {
    let urlToParse: string = url;
    if (urlToParse.endsWith('/')) {
      urlToParse = urlToParse.slice(0, -1);
    }
    return super.parse(urlToParse);
  }

  override serialize(tree: UrlTree): string {
    let url: string = super.serialize(tree);

    if (url !== '/') {
      url = addSlashToBasePath(url);
    }

    return url;
  }
}
